import { render } from "./PCLecturaCajasPicking.vue?vue&type=template&id=2c2d2196"
import script from "./PCLecturaCajasPicking.vue?vue&type=script&lang=js"
export * from "./PCLecturaCajasPicking.vue?vue&type=script&lang=js"

import "./PCLecturaCajasPicking.vue?vue&type=style&index=0&id=2c2d2196&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__